import { getIncidentTypeLabel, isIncidentType } from "./incidentReport";
import { getReportAuthorEmail } from "./reportAuthor";
import {
	getReportAuthorName,
	getReportPlaceParts,
	StreamPlaceReport,
	StreamPlaces,
} from "./reportStream";

// The fields of an incident report the Incident stream reads.
export type StreamIncident = StreamPlaceReport & {
	report_number?: unknown;
	title?: unknown;
	description?: unknown;
	incident_type?: unknown;
	operator?: string;
	primary_author?: string | null;
	author?: string | null;
};

// The report's type, when it is one the report form offers. A report with
// another type or none shows no tag and isn't in the type filter.
export const getIncidentType = (report: StreamIncident) =>
	isIncidentType(report.incident_type) ? report.incident_type : undefined;

// The line under an incident report's title: its type, then where it
// belongs.
export function getIncidentMeta(report: StreamIncident, places: StreamPlaces) {
	const type = getIncidentType(report);
	return {
		tag: type === undefined ? undefined : getIncidentTypeLabel(type),
		parts: getReportPlaceParts(report, places),
	};
}

// What the stream's search looks through for an incident report.
export function getIncidentSearchTexts(
	report: StreamIncident,
	places: StreamPlaces,
	authorNames: Record<string, string>,
	getTenantName: (tenantKey: string) => string | undefined
) {
	const { tag, parts } = getIncidentMeta(report, places);
	return [
		report.report_number,
		report.title,
		report.description,
		tag,
		...parts,
		getReportAuthorEmail(report),
		getReportAuthorName(report, authorNames),
		report.operator ? getTenantName(report.operator) : undefined,
	];
}
